var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.content,"placement":_vm.placement,"open-delay":_vm.openDelay,"disabled":_vm.disabled,"effect":"dark","popper-class":"ui-tooltip"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }